import { AccountCategory, AccountDateRange, AccountSlugs } from 'Types/account';

export const DEFAULT_ACCOUNT_DATE_RANGES = [
	AccountDateRange.ALL,
	AccountDateRange.TODAY,
	AccountDateRange.YESTERDAY,
	AccountDateRange.LAST_7_DAYS,
	AccountDateRange.LAST_30_DAYS,
];

export const ACCOUNT_PAGE_VARIATIONS = [
	{ category: AccountCategory.PURCHASES, slug: AccountSlugs.COMPLETE },
	{ category: AccountCategory.PURCHASES, slug: AccountSlugs.CANCELLED },
];

export const COUNTS_MOCK_API_RESPONSE = { active: 0, cancelled: 0, complete: 0 };

export const STATUS_COUNTS_MOCK_API_RESPONSE = {
	allStatus: 12220,
	awaitingConfirmation: 3000,
	checksComplete: 999,
	deliveryRequested: 1000,
	reviewingDocs: 0,
};

export const STATUS_COUNTS_TEXT_CONTENT = {
	allStatus: '12.2k',
	awaitingConfirmation: '3k',
	checksComplete: '999',
	deliveryRequested: '1k',
	reviewingDocs: '0',
};
